import { useEffect, useRef } from "react";

import { useLocation } from "react-router-dom";

import { decryptData } from "../utils/encryption";
import { normalizeEmail } from "../utils/normalizeEmail";

const useLoginQueryParams = (form, login) => {
    const location = useLocation();
    const autoLoginAttemptedRef = useRef(false);

    useEffect(() => {
        if (autoLoginAttemptedRef.current) {
            return;
        }

        const queryParams = new URLSearchParams(location.search);
        const encryptedEmail = queryParams.get("var1");
        const encryptedPassword = queryParams.get("var2");

        if (!encryptedEmail || !encryptedPassword) {
            return;
        }

        autoLoginAttemptedRef.current = true;

        const decryptedEmail = decryptData(encryptedEmail);
        const decryptedPassword = decryptData(encryptedPassword);

        if (!decryptedEmail || !decryptedPassword) {
            return;
        }

        const email = normalizeEmail(decryptedEmail);
        const password = decryptedPassword.trim();

        form.setFieldsValue({ email, password });
        login({ email, password });
    }, [form, location.search, login]);
};

export default useLoginQueryParams;
